<h1 class="title">Review Your Order</h1>
<p class="instructions">Please review the information below for accuracy and confirm your order.</p>
<form [formGroup]="emailForm" (ngSubmit)="completeOrder(emailForm.value)">
  <div class="details-container">
    <div class="workbook-detail">
      <h3 class="detail-title">Shipping Address</h3>
      <ng-container *ngIf="candidate">
        <p class="details">{{ candidate.firstName }} {{ candidate.lastName }}</p>
        <p class="details">{{ candidate.addressLine }} {{ candidate.apt }}</p>
        <p class="details">
          {{ candidate.city ? candidate.city + ', ' : '' }}{{ candidate.region }} {{ candidate.postalCode }}
        </p>
      </ng-container>
      <a class="button button-secondary button-pill button-edit" routerLink="/welcome/workbook/edit">
        <svg-icon class="edit-icon" src="/assets/icons/edit.svg"></svg-icon>
        <span>Edit</span>
      </a>
    </div>
    <div class="workbook-detail">
      <h3 class="detail-title">Purposeful Workbook</h3>
      <p class="details">Arrives in 3-5 weeks</p>
    </div>
    <div class="workbook-detail">
      <h3 class="detail-title">Email Address</h3>
      <p class="email-description">
        We’ll use this to send you a confirmation email and a follow-up survey after you receive the workbook.
      </p>
      <input class="email-input" type="text" placeholder="Enter an email address" required formControlName="email" />
    </div>
  </div>
  <div *ngIf="isAddressInvalid || emailForm.invalid" class="error">
    <svg-icon src="/assets/icons/alert-circle.svg" class="icon-error"></svg-icon>
    <p>Please ensure that your shipping address and email information are correct.</p>
  </div>
  <div *ngIf="error" class="error">
    <svg-icon src="/assets/icons/alert-circle.svg" class="icon-error"></svg-icon>
    <!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
    <!-- prettier-ignore -->
    <p>
      Unfortunately, there was a problem placing your order. If this issue persists, please reach out to
      <a class="email-link" href="mailto:support@kumanu.com?subject=Help Needed with Workbook Order">support@kumanu.com</a>.
    </p>
  </div>
  <button class="button button-pill button-confirm" type="submit" [disabled]="isAddressInvalid || emailForm.invalid">
    Confirm
  </button>
</form>
